// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "19bfcde0fab448db","396": "056c391cd7f1c434","460": "26e167e67bcb6aa3","498": "ec5acee4758f0aff","917": "a6113f619a829718","985": "490b93301f29b4d5",}[chunkId] + ".chunk.js"
}